import React, { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { List } from '@mui/material';
import SubAccountListItem from './SubAccountListItem';

import {
    ListItem, ListItemAvatar,
    ListItemText, Avatar,
} from '@mui/material';
import { getSubAccounts, subaccountListSelector, reloadlistSelector } from '../../features/subaccounts/subaccountSlice';


const SubAccountListView = () => {
    const dispatch = useDispatch();
    const subaccountList = useSelector(subaccountListSelector);
    const reloadlist = useSelector(reloadlistSelector);

    useEffect(() => {
        if (reloadlist) {
            dispatch(getSubAccounts());
        }
    }, [dispatch, reloadlist]);

    useEffect(() => {
        //console.log("SA List", subaccountList);
    }, [subaccountList])

    const listItems = () => {
        let thelist = [];
        if (subaccountList && subaccountList.length > 0) {
            subaccountList.forEach((subaccount, index) => {
                thelist.push(<Fragment key={index}>
                    <SubAccountListItem subaccount={subaccount} />
                </Fragment>);
            })
        }

        if (subaccountList && subaccountList.length === 0) {
            thelist.push(
                <ListItem key="noevent">
                    <ListItemAvatar>
                        <Avatar style={{ backgroundColor: 'Crimson' }}>
                            0
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="No Sub Accounts Found" />

                </ListItem>
            );
        }
        return thelist;
    }

    return (
        <div>
            {
                subaccountList && subaccountList.length > 0 &&
                <List disablePadding>{listItems()}</List>
            }
        </div>
    )
}

export default SubAccountListView;
